<!-- anymatch lists its matches without rating them: no rate/rated tabs; an embedded job app has
     them in the app bar instead (toolbar-layout) -->
@if (!stopMode && !embedded) {
  <mat-toolbar style="background: transparent" data-testid="matching-toolbar">
    <mat-toolbar-row
      class="no-select"
      ngStyle.gt-sm="padding-inline: 200px"
      fxLayoutAlign="space-around center"
    >
      <!-- Explicit tabindex: stock Safari only tabs to elements with one set. -->
      <button
        mat-button
        routerLink="/matching/rate"
        routerLinkActive="selected"
        tabindex="0"
        data-testid="toolbar-rate-button"
      >
        <mat-icon color="accent">thumbs_up_down</mat-icon
        ><span
          class="accent"
          [matBadge]="unratedMatchesCount$ | async"
          matBadgeColor="accent"
          matBadgeSize="small"
          [matBadgeOverlap]="false"
          matBadgePosition="above after"
          data-testid="toolbar-rate-badge"
          >{{ 'RATED_MATCHES.title' | translate }}</span
        >
      </button>
      <button
        #ratedTabBtn
        mat-button
        routerLink="/matching/rated"
        routerLinkActive="selected"
        [class.has-new]="showRatedTabPulse$ | async"
        tabindex="0"
        data-testid="toolbar-rated-button"
      >
        <mat-icon color="accent">check_circle</mat-icon
        ><span
          [matBadge]="ratedMatchesCount$ | async"
          matBadgeColor="accent"
          [matBadgeOverlap]="false"
          matBadgePosition="above after"
          matBadgeSize="small"
          data-testid="toolbar-rated-badge"
          class="accent"
        >
          <span fxHide.xs>{{ 'MATCHING.rated' | translate }}</span>
          <span fxHide.gt-xs>{{ 'MATCHING.rated_xs' | translate }}</span>
        </span>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
}
<div class="content" [class.full]="stopMode || embedded">
  <div class="nav-content height-match-parent">
    @if (show) {
      <router-outlet />
    }
  </div>
</div>
@if (showSpotlight && ratedTabBtn) {
  <recrewt-spotlight-overlay
    [targetElement]="ratedTabBtn.nativeElement"
    [message]="'MATCHING.rated_tab_spotlight_hint'"
    [priority]="mascotPriority.HINT"
    (dismiss)="onSpotlightDismiss()"
  />
}
